import { render, staticRenderFns } from "./SaleNoteList.vue?vue&type=template&id=6a34d85e&scoped=true&"
import script from "./SaleNoteList.vue?vue&type=script&lang=js&"
export * from "./SaleNoteList.vue?vue&type=script&lang=js&"
import style0 from "./SaleNoteList.vue?vue&type=style&index=0&id=6a34d85e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a34d85e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a34d85e')) {
      api.createRecord('6a34d85e', component.options)
    } else {
      api.reload('6a34d85e', component.options)
    }
    module.hot.accept("./SaleNoteList.vue?vue&type=template&id=6a34d85e&scoped=true&", function () {
      api.rerender('6a34d85e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/Invoices/History/SaleNoteList.vue"
export default component.exports